import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_3 = { class: "flex card-toolbar w-full" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "p-input-icon-left w-10/12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "card-toolbar w-full" }
const _hoisted_8 = { class: "flex flex-col justify-center" }
const _hoisted_9 = { class: "card-toolbar w-full" }
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = { class: "card-body pt-0" }
const _hoisted_12 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_14 = { class: "d-flex flex-row" }

import DataTable from "primevue/datatable";
import { ref, onMounted } from 'vue';
import { useRoute } from "vue-router";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Column from "primevue/column";
import InputSwitch from "primevue/inputswitch";
import swal from "@/_helpers/swal";
import router from "@/router";
import {
  deleteShippingMethod,
  fetchShippingMethodBySupplier,
  IShippingMethod,
  triggerShippingMethodState
} from "@/_services/shippingMethod/shippingMethod"

export default /*#__PURE__*/_defineComponent({
  __name: 'PageShippingMethod',
  setup(__props) {

const shippingMethod = Array<IShippingMethod>();
const tableData = ref<Array<IShippingMethod>>(shippingMethod);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
  fieldLabel: "order[createdAt]",
  fieldValue: "desc",
};
const supplierUuid = ref<string>("");
const route = useRoute();

onMounted(async () => {
  supplierUuid.value = route.params.uuid as string;
  await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
  showSpinner();
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchShippingMethodBySupplier(
    supplierUuid.value,
    itemsPerPage,
    page,
    criteria,
    sort
  );
  totalRecords.value = totalRecordsDt.value;
  tableData.value = tableDataDt.value;
  isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
  rows.value = e.rows;
  populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onDelete = (data: IShippingMethod) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer le moyen d’expédition ?")
        .then(async (result) => {
            if (result.isConfirmed) {
               const deletionAllowed = await deleteShippingMethod(data.uuid);
               if(!deletionAllowed) {
                   swal.error("Vous ne pouvez pas supprimer le moyen d’expédition car il est rattaché à au moins 1 produit actif.");
               } else {
                   swal.success("Supprimer !", "Vous venez de supprimer un moyen d’expédition");
                   populateDatatable(rows.value, page.value, criteria.value);
               }
            }
        });
};

const onSort = (e) => {
  if (e.sortField) {
    const sort = {
      fieldLabel: "order[" + e.sortField + "]",
      fieldValue: e.sortOrder === 1 ? "asc" : "desc",
    };
    modeSortable.value = true;
    populateDatatable(rows.value, page.value, criteria.value, sort);
  } else {
    modeSortable.value = false;
    populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
  }
};

const changeState = async (uuid: string, status: number) => {
  const confirmationMessage = status
    ? "Êtes-vous sûr de vouloir activer le moyen d’expédition ?"
    : "Êtes-vous sûr de vouloir désactiver le moyen d’expédition ?";

  const result = await swal.confirm(confirmationMessage);

  if (result.isConfirmed) {
    await triggerShippingMethodState(uuid, status);
    const successMessage = status
      ? "Vous venez d'activer un moyen d’expédition."
      : "Vous venez de désactiver un moyen d’expédition.";

    swal.info(successMessage);
  }
  populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
};

const onSearchInputDt = () => {
  if (0 === criteria.value.length || 3 <= criteria.value.length) {
    populateDatatable(
      rows.value,
      page.value,
    "" != criteria.value ? criteria.value : ""
    );
  }
}

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      lazy: "",
      value: tableData.value,
      paginator: true,
      rows: rows.value,
      removableSort: "",
      loading: isLoading.value,
      totalRecords: totalRecords.value,
      currentPage: currentPage.value,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 100],
      currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
      onPage: _cache[3] || (_cache[3] = ($event: any) => (onPaginate($event))),
      onSort: _cache[4] || (_cache[4] = ($event: any) => (onSort($event)))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createVNode(_unref(InputText), {
                  type: "text",
                  class: "w-9/12",
                  modelValue: criteria.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                  placeholder: "Rechercher...",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onSearchInputDt()), ["enter"]))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, "Nombre total de moyens d'expédition : " + _toDisplayString(totalRecords.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(Button), {
                size: "small",
                class: "btn btn-primary p-2 ps-2 pe-2",
                style: {"margin-right":"0.5em"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'addShippingMethod', params: { uuid: supplierUuid.value.value } }))),
                title: "Ajouter un moyen d'expédition"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ajouter un moyen d'expédition ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("Aucun moyen d'expédition ne correspond à votre recherche")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(Column), {
            field: "name",
            header: "Intitulé",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "transporter",
            header: "transporteur",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.transporter.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "deliveryTime",
            header: "Délai",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.deliveryTime), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "createdBy",
            header: "Créé par",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.createdBy), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "status",
            header: "Etat",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.status)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Actif "))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, " Inactif "))
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "action",
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-pencil",
                  class: "p-edition",
                  style: {"margin-right":"0.5em"},
                  title: "Éditer",
                  onClick: ($event: any) => (_unref(router).push({ name: 'editShippingMethod', params: { uuid: slotProps.data.uuid } }))
                }, null, 8, ["onClick"]),
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-trash",
                  class: "p-button-danger",
                  style: {"margin-right":"0.5em"},
                  title: "Éditer",
                  onClick: ($event: any) => (onDelete(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_unref(InputSwitch), {
                  modelValue: slotProps.data.status,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.status) = $event),
                  onInput: ($event: any) => (changeState(slotProps.data.uuid, slotProps.data.status))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"])
  ]))
}
}

})